// 9fbef606107a605d69c0edbcd8029e5d
import {
  SET_DY_RECOMMENDATIONS_DATA,
  SET_DY_LOADING_STATE,
  CLEAR_DY_RECOMMENDATIONS_DATA,
} from './DyRecommendations.constants';

const initialState = {};

export default function dyReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DY_RECOMMENDATIONS_DATA:
      return {
        ...state,
        [action.payload.pageName]: {
          loading: state[action.payload.pageName]?.loading,
          ...action.payload.data,
        },
      };

    case SET_DY_LOADING_STATE:
      return {
        ...state,
        [action.payload.pageName]: {
          ...state[action.payload.pageName],
          loading: action.payload.value,
        },
      };

    case CLEAR_DY_RECOMMENDATIONS_DATA: {
      const newState = { ...state }; // Create a shallow copy
      delete newState[action.keyToDelete];
      return newState;
    }

    default:
      return state;
  }
}
